
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";

@Component({
  name: "TableBoxText",
  components: {},
})
export default class TableBoxText extends Vue {
  @Prop({ type: Array }) tableData!: any;
  @Prop({ type: Boolean }) loading!: any;
  handleClick(item: any) {
    this.$emit("handleClick", item);
  }
}
